import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/authContext"; 

const GoogleAuthCallback = () => {
  const navigate = useNavigate();
  const { googleLogin } = useContext(AuthContext); 

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("token");

    if (token) {
      console.log("Token received:", token);

      googleLogin(token)
        .then(() => {
          console.log("Google login successful! Redirecting...");
          navigate("/properties"); 
          window.history.replaceState({}, document.title, "/properties"); 
        })
        .catch((error) => {
          console.error(" Google login failed:", error);
          navigate("/login"); 
        });
    } else {
      console.error("No token found in URL. Redirecting to login.");
      navigate("/login"); 
    }
  }, [googleLogin, navigate]);

  return <div>Authenticating with Google...</div>;
};

export default GoogleAuthCallback;
